import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "items selectable" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "badge rounded-pill bg-danger"
}
const _hoisted_7 = { class: "item-info" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "item placeholder-glow"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "item-logo placeholder placeholder-lg col-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "item-name placeholder placeholder-lg col-6" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "item-info placeholder placeholder-lg col-1" }, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_secured_image = _resolveComponent("secured-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tribesContent, (tribe, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["item", { 'have-action': false, selected: tribe.id === _ctx.tribeURLId }]),
        id: 'tribeItem-' + tribe.id
      }, [
        _createVNode(_component_router_link, {
          custom: "",
          to: {
          name: `${_ctx.modeRouteName}TribeDiscussionMembers`,
          params: { id: tribe.id },
        }
        }, {
          default: _withCtx(({ navigate, href }) => [
            _createElementVNode("div", {
              class: "item-logo",
              href: href,
              onClick: navigate
            }, [
              (!tribe.avatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(tribe.name?.substring(0, 2).toUpperCase() ?? ""), 1))
                : _createCommentVNode("", true),
              (tribe.avatar !== undefined)
                ? (_openBlock(), _createBlock(_component_secured_image, {
                    key: 1,
                    src: tribe.avatar
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["to"]),
        _createVNode(_component_router_link, {
          custom: "",
          to: {
          name: `${_ctx.modeRouteName}TribeDiscussionMembers`,
          params: { id: tribe.id },
        }
        }, {
          default: _withCtx(({ navigate, href }) => [
            _createElementVNode("div", {
              class: "item-name",
              onClick: ($event: any) => (_ctx.clickItem(tribe, navigate, href))
            }, _toDisplayString(tribe.name ?? ""), 9, _hoisted_5)
          ]),
          _: 2
        }, 1032, ["to"]),
        (tribe.knocks && tribe.knocks > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tribe.knocks), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: "treebal-chat-rounded-square text-secondary",
            title: _ctx.$t(`tribes.types.discussion`)
          }, null, 8, _hoisted_8)
        ])
      ], 10, _hoisted_2))
    }), 128)),
    (_ctx.tribes && _ctx.tribes.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, !_ctx.loading]
  ])
}